var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form__group" },
    [
      _c("label", { staticClass: "form__label", attrs: { for: _vm.name } }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm._v(" "),
      _c("date-picker", {
        attrs: {
          id: _vm.name,
          name: _vm.name,
          type: "datetime",
          format: _vm.format,
          "value-type": "format",
          "default-value": _vm.formattedDefaultDate,
          "disabled-date": _vm.disableDates,
          "input-class": "form__control",
          required: "",
        },
        on: { change: _vm.updateNow },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }